import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const EXPLORE_URL = process.env.REACT_APP_EXPLORE_URL;

const COLUMNS = [
  {
    title: "Explore",
    links: [
      { href: EXPLORE_URL, label: "Trail Map", testid: "footer-link-trail-map" },
      { to: "/pricing", label: "Pricing", testid: "footer-link-pricing" },
      { to: "/riders", label: "For Riders", testid: "footer-link-riders" },
      { to: "/businesses", label: "For Businesses", testid: "footer-link-businesses" },
      { to: "/partners", label: "For Partners", testid: "footer-link-rental-shops" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About VeloPaths", testid: "footer-link-about" },
      { to: "/contact", label: "Contact", testid: "footer-link-contact" },
      { to: "/press", label: "Press Kit", testid: "footer-link-press" },
      { to: "/privacy", label: "Privacy Policy", testid: "footer-link-privacy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B2B22] text-[#F4F7F4]">
      <div data-testid="footer-countdown" className="border-b border-[#F4F7F4]/10">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-1.5 px-6 py-4 sm:px-10 lg:px-16">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-[#7FB998]">
            Available now on the App Store and Google Play
          </p>
          <Link
            to="/riders#waitlist"
            data-testid="footer-countdown-link"
            className="-my-3 inline-flex items-center gap-1 py-3 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#E05A47] transition-colors hover:text-[#f0756a]"
          >
            Get the app <ArrowUpRight size={12} />
          </Link>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-10 sm:py-20 lg:px-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Link to="/" data-testid="footer-logo" className="inline-flex items-center">
              <span className="inline-flex items-center rounded-xl bg-white px-3 py-2">
                <img src="/velopaths-logo.png" alt="VeloPaths" className="h-7 w-auto" />
              </span>
            </Link>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-[#F4F7F4]/60">
              Connecting cyclists, local businesses, and cycling communities. Beautiful routes,
              curated stops, and a platform where whole trail towns thrive.
            </p>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-[#7FB998]">
              41.4901° N · 71.3128° W — wherever the path leads
            </p>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title} className="lg:col-span-3">
              <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#F4F7F4]/40">
                {col.title}
              </p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.testid}>
                    {l.href ? (
                      <a
                        href={l.href}
                        data-testid={l.testid}
                        className="group inline-flex items-center gap-1.5 py-2 text-sm font-semibold text-[#F4F7F4]/80 transition-colors hover:text-[#E05A47]"
                      >
                        {l.label}
                        <ArrowUpRight
                          size={14}
                          className="opacity-0 transition-opacity group-hover:opacity-100"
                        />
                      </a>
                    ) : (
                      <Link
                        to={l.to}
                        data-testid={l.testid}
                        className="group inline-flex items-center gap-1.5 py-2 text-sm font-semibold text-[#F4F7F4]/80 transition-colors hover:text-[#E05A47]"
                      >
                        {l.label}
                        <ArrowUpRight
                          size={14}
                          className="opacity-0 transition-opacity group-hover:opacity-100"
                        />
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-[#F4F7F4]/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-[#F4F7F4]/45">© 2026 VeloPaths. All rights reserved.</p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#F4F7F4]/45">
            Explore Every Path. Discover Every Stop.
          </p>
        </div>
      </div>
    </footer>
  );
}
